<template>
  <div class="app-row">
    <img :src="app.icon" :alt="t(relatedAppNameKey(app.i18nKey))" class="app-icon" />
    <div class="app-info">
      <div class="name-row">
        <van-tag v-if="app.isAd" plain type="primary" color="#6b7280" class="ad-tag">
          {{ t('appStore.ad') }}
        </van-tag>
        <span class="name">{{ t(relatedAppNameKey(app.i18nKey)) }}</span>
      </div>
      <p class="subtitle">{{ t(relatedAppSubtitleKey(app.i18nKey)) }}</p>
      <div class="action-row">
        <van-icon v-if="app.installed" name="down" size="20" color="#007AFF" />
        <template v-else>
          <van-button round size="mini" class="get-btn">{{ t('appStore.action') }}</van-button>
          <span class="iap">{{ t('appStore.inAppPurchases') }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import type { RelatedApp } from '@/lib/app-data';
import { relatedAppNameKey, relatedAppSubtitleKey } from '../i18n-keys';

defineProps<{ app: RelatedApp }>();

const { t } = useI18n();
</script>

<style scoped>
.app-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 230px;
  flex-shrink: 0;
}

.app-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  background: #f3f4f6;
}

.app-info {
  flex: 1;
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ad-tag {
  font-size: 9px;
  padding: 0 4px;
}

.name {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.get-btn {
  background: rgba(0, 0, 0, 0.06);
  border: none;
  color: #007AFF;
  font-weight: 600;
  padding: 0 14px;
}

.iap {
  font-size: 10px;
  color: #6b7280;
}
</style>
